// ** React Imports
import React from "react"
import { Suspense, lazy } from "react"

// ** Router Components
import {
	BrowserRouter as AppRouter,
	Route,
	Switch,
	Redirect,
} from "react-router-dom"
import { useSkin } from "../utility/hooks/useSkin"

// ** Routes & Default Routes
import { DefaultRoute, Routes } from "./routes"

const Router = () => {
	useSkin()

	// Lazy loading other pages
	const NotAuthorized = lazy(() => import("@src/views/NotAuthorized"))
	const Error = lazy(() => import("@src/views/Error"))
	const isUserLoggedIn = () => !!localStorage.getItem("token")

	return (
		<AppRouter basename={process.env.REACT_APP_BASENAME}>
			<Switch>
				<Route
					exact
					path="/"
					render={() => {
						return isUserLoggedIn() ? (
							<Redirect to={DefaultRoute} />
						) : (
							<Redirect to="/login" />
						)
					}}
				/>
				<Route
					exact
					path="/not-authorized"
					render={() => <NotAuthorized />}
				/>

				{Routes.map((route) => {
					return (
						<Route
							key={route.path}
							path={route.path}
							exact={route.exact === true}
							render={(props) => {
								// ** Assign props to routerProps
								// Object.assign(routerProps, {
								// 	...props,
								// 	meta: route.meta,
								// })

								return (
									<Suspense fallback={null}>
										{/* Layout Wrapper to add classes based on route's layout, appLayout and className */}
										<route.component {...props} />
										{/* <FinalRoute route={route} {...props} /> */}
									</Suspense>
								)
							}}
						/>
					)
				})}

				{/* NotFound Error page */}
				<Route path="*" component={Error} />
			</Switch>
		</AppRouter>
	)
}

export default Router
